module.exports = __webpack_public_path__ + "img/user.7d6365d3.svg";